import type { BasketItem } from "@nwt/norce-pwa/dist/runtime/types/api/shopping/basket";
import { VARIANT_INFO_CODES } from "./basketItemInfoCodes";

const labelFromInfo = (info: BasketItem["Info"] | undefined): string => {
	if (!Array.isArray(info) || info.length === 0) return "";

	return VARIANT_INFO_CODES.map(
		(code) => info.find((entry) => entry?.Code === code)?.Value
	)
		.filter((value): value is string => !!value && value.trim().length > 0)
		.join("/");
};

/**
 * Size and colour of a basket line, e.g. "XS/Dark Navy". A line Norce splits
 * off for a promotion has empty `Info`, so it borrows the label from a line
 * with the same `PartNo` (BB-174).
 */
export const resolveVariantLabel = (
	item: Partial<BasketItem>,
	basketItems: Partial<BasketItem>[] | undefined
): string => {
	const own = labelFromInfo(item.Info);
	if (own || !item.PartNo) return own;

	for (const sibling of basketItems ?? []) {
		if (sibling === item || sibling.PartNo !== item.PartNo) continue;
		const label = labelFromInfo(sibling.Info);
		if (label) return label;
	}

	return "";
};
